import { motion, useReducedMotion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { SCREEN_RANGES } from "../data/quiz";

const EASE = [0.22, 1, 0.36, 1];

export function RealityCheck({ selected, onSubmit, onBack }) {
  const reduce = useReducedMotion();

  return (
    <main data-testid="reality-check-screen" className="pt-10 sm:pt-14">
      <motion.div
        initial={reduce ? false : { opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: EASE }}
      >
        <p className="text-[12px] font-semibold uppercase tracking-[0.22em] text-teal">
          Reality check
        </p>
        <h1 className="mt-4 font-display text-2xl font-bold leading-snug sm:text-3xl">
          Cât timp ai petrecut ieri pe telefon?
        </h1>

        <ul className="mt-7 space-y-3">
          {SCREEN_RANGES.map((range, i) => (
            <li key={i}>
              <motion.button
                data-testid={`screen-range-${i}`}
                onClick={() => onSubmit(range)}
                whileTap={{ scale: 0.985 }}
                className={`w-full min-h-[52px] rounded-2xl border px-5 py-3.5 text-left text-[15px] leading-relaxed text-[#F7FAFC] transition-[background-color,border-color,box-shadow] duration-200 sm:text-base ${
                  selected === range
                    ? "glow-soft border-tealbright bg-selectbg text-white"
                    : "border-teal/40 bg-answerbg hover:border-teal hover:bg-hoverbg hover:shadow-[0_0_14px_rgba(32,214,199,0.12)]"
                }`}
              >
                {range}
              </motion.button>
            </li>
          ))}
        </ul>

        <p className="mt-6 text-[13px] leading-relaxed text-soft/80">
          Timpul total nu spune singur toată povestea. Contează și cât de intenționat folosești
          telefonul.
        </p>

        <button
          data-testid="back-button"
          onClick={onBack}
          className="mt-8 inline-flex min-h-[52px] items-center gap-2 rounded-full px-3 text-[15px] text-teal transition-colors duration-200 hover:text-ink"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Înapoi
        </button>
      </motion.div>
    </main>
  );
}
